module.exports = __webpack_public_path__ + "static/media/SaifeeEvents264.4d1d2ae5.jpg";